import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-return-dialog',
  templateUrl: './confirm-return-dialog.component.html',
  styleUrls: ['./confirm-return-dialog.component.scss']
})

export class ConfirmReturnDialogComponent {
  [x: string]: any;
  isDirty: any;
  isActionChecked: boolean = false;
  primaryBtnClass: string = 'primary'
  icon: string = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmReturnDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    if (this.data.action === 'Delete' || this.data.continue === 'Delete') {
      this.icon = '/assets/icons/user_icons/Alert_Delete.svg';
    } else if (this.data.action === 'Warning') {
      this.icon = '/assets/icons/user_icons/Alert_Warning.svg';
    } else {
      this.icon = '/assets/icons/user_icons/Alert_Warning.svg';
    }
  }

  onNoClick() {
    this.isDirty = false;
    this.dialogRef.close('true');
    this.canDeactivate();
  }

  canDeactivate(): boolean {
    return true
  }

  ifExists(alert) {
    let messages = ["Permanently Delete Record", "Are you sure to De-Associate the selected location(s)?"]
    return messages.includes(alert) || alert.includes('Permanently Delete Record');
  }

  onCheckboxClick(event) {
    this.isActionChecked = event;
  }

  getButtonText(): string {
    if (this.data.action === 'Delete') {
      return 'Delete';
    }
    return this.data.continue || 'OK';
  }

}